//REACT
require('react');
require('react-dom');
require('react-redux');
require('react-router');

//REDUX
require('redux');
require('redux-thunk');

//DRAFT.JS
require('draft-js');
require('draft-js-export-html');
require('draft-js-import-html');
require('draft-js-utils');

//material-ui
//@TODO - reduce
require('material-ui');



// WEBPACK FOOTER //
// ./src/vendors.js